import { Injectable } from '@angular/core';
import { IEvent } from '@shared/interfaces/event.interface';
import { IFilter } from '@shared/interfaces/filter.interface';
import { Filter } from '@shared/models/filter.model';
import { EventsService } from '@shared/services/events.service';
import { LoggerService } from '@shared/services/logger.service';
import { PaginationService } from '@shared/services/pagination/pagination.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationEventsService extends PaginationService<IEvent> {
  private static readonly DEFAULT_IS_DELETED_FILTER: IFilter = {
    label: 'COMMON.ACTIVE',
    key: 'isDeleted',
    value: 'false'
  };

  private static readonly DEFAULT_IS_OVER_FILTER: IFilter = {
    label: 'COMMON.IS_OVER',
    key: 'isPaused',
    value: 'false'
  };

  private static readonly DEFAULT_PARENT_LOCATION_FILTER: IFilter = {
    key: 'parentLocation',
    value: null
  };

  private static readonly DEFAULT_IGNORE_ONE_TIME_FILTER: IFilter = {
    key: 'ignoreOneTime',
    value: true
  };

  private static readonly DEFAULT_LIMIT_FILTER: IFilter = {
    key: 'limit',
    value: 15
  };

  private static readonly DEFAULT_SEARCH_FILTER: IFilter = {
    key: 'search',
    value: ''
  };

  private _filtersScope: any;

  constructor(_paginable: EventsService, _logger: LoggerService) {
    super(_paginable, _logger);

    this.setFilters([
      PaginationEventsService.DEFAULT_IS_DELETED_FILTER,
      PaginationEventsService.DEFAULT_PARENT_LOCATION_FILTER,
      PaginationEventsService.DEFAULT_IS_OVER_FILTER,
      PaginationEventsService.DEFAULT_IGNORE_ONE_TIME_FILTER,
      PaginationEventsService.DEFAULT_LIMIT_FILTER,
      PaginationEventsService.DEFAULT_SEARCH_FILTER
    ]);
  }

  public getFilters(): IFilter[] {
    return this._filtersScope;
  }

  public reset() {
    super.reset();

    this.setFilters([
      PaginationEventsService.DEFAULT_IS_DELETED_FILTER,
      PaginationEventsService.DEFAULT_PARENT_LOCATION_FILTER,
      PaginationEventsService.DEFAULT_IS_OVER_FILTER,
      PaginationEventsService.DEFAULT_IGNORE_ONE_TIME_FILTER,
      PaginationEventsService.DEFAULT_LIMIT_FILTER,
      PaginationEventsService.DEFAULT_SEARCH_FILTER
    ]);
  }

  public setFilters(filters: Partial<IFilter>[]): void {
    this._filtersScope = filters.map((f) => new Filter(f));
    super.setFilters(this._filtersScope);
  }
}
